import styled from "styled-components";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
  box-shadow: ${({ theme }) => theme.shadow};
  margin-top: 2rem;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem auto;
`;

export const WrapperBtn = styled.div`
  margin: 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
